// import { defaultLocale, localeOptions } from '../../constants/defaultValues'

import {
	LOGOUT_USER,

	// ServiceFee Management
	SETTING_LOAD_SERVICE_FEE,
	SETTING_LOAD_SERVICE_FEE_SUCCESS,
	SETTING_CREATE_SERVICE_FEE,
	SETTING_UPDATE_SERVICE_FEE,
	SETTING_DELETE_SERVICE_FEE,

	// SETTING_LOAD_POSITION,
	// SETTING_LOAD_POSITION_SUCCESS,
	// SETTING_CREATE_POSITION,
	// SETTING_UPDATE_POSITION,
	// SETTING_DELETE_POSITION,

	// SETTING_LOAD_STAFF,
	// SETTING_LOAD_STAFF_SUCCESS,
	// SETTING_CREATE_STAFF,
	// SETTING_UPDATE_STAFF,
	// SETTING_DELETE_STAFF,
	// END ServiceFee Management


} from '../../actions';

const INIT_STATE = {

	serviceFee: [],
	optionServiceFee: [],

	// position: [],
	// optionPosition: [],

	// staff: [],
	// optionStaff: [],

	serviceFeeLoading: false,
	// positionLoading: false,
	// staffLoading: false,

};

export default (state = INIT_STATE, action) => {
	switch (action.type) {

		case SETTING_LOAD_SERVICE_FEE:
			return { ...state, serviceFeeLoading: true }
		case SETTING_LOAD_SERVICE_FEE_SUCCESS:
			return {
				...state,
				serviceFeeLoading: false,
				serviceFee: action.payload,
				optionServiceFee: action.payloadlist
			}
		case SETTING_CREATE_SERVICE_FEE:
			return { ...state, serviceFeeLoading: true }
		case SETTING_UPDATE_SERVICE_FEE:
			return { ...state, serviceFeeLoading: true }
		case SETTING_DELETE_SERVICE_FEE:
			return { ...state, serviceFeeLoading: true }

		// case SETTING_LOAD_POSITION:
		// 	return { ...state, positionLoading: true }
		// case SETTING_LOAD_POSITION_SUCCESS:
		// 	return {
		// 		...state,
		// 		positionLoading: false,
		// 		position: action.payload,
		// 		optionPosition: action.payloadlist
		// 	}
		// case SETTING_CREATE_POSITION:
		// 	return { ...state, positionLoading: true }
		// case SETTING_UPDATE_POSITION:
		// 	return { ...state, positionLoading: true }
		// case SETTING_DELETE_POSITION:
		// 	return { ...state, positionLoading: true }

		// case SETTING_LOAD_STAFF:
		// 	return { ...state, staffLoading: true }
		// case SETTING_LOAD_STAFF_SUCCESS:
		// 	return {
		// 		...state,
		// 		staffLoading: false,
		// 		staff: action.payload,
		// 		optionStaff: action.payloadlist
		// 	}
		// case SETTING_CREATE_STAFF:
		// 	return { ...state, staffLoading: true }
		// case SETTING_UPDATE_STAFF:
		// 	return { ...state, staffLoading: true }
		// case SETTING_DELETE_STAFF:
		// 	return { ...state, staffLoading: true }

		case LOGOUT_USER:
			return {
				...state,
				serviceFee: [],
				optionServiceFee: [],

				// position: [],
				// optionPosition: [],

				// staff: [],
				// optionStaff: [],

				serviceFeeLoading: false,
				// positionLoading: false,
				// staffLoading: false,
			};

		default: return { ...state };
	}
}